let $ = require('jquery');
let Promise = require('bluebird');
let errorBlock = require('templates/error-block.hbs');

module.exports = ($form, response) => new Promise((resolve, reject) => {
    let {errors, messages, data} = response.body;

    $form
        .find('.error-bag')
        .remove();

    $form
        .find('.form-group')
        .removeClass('has-error');

    errors.forEach(function (item) {
        let $input = $form
            .find(`[name=${item.field}]`);

        let $group = $input.parents('.form-group');

        $group
            .addClass('has-error')
            .append(errorBlock(item));
    });

    if (errors.length) {
        reject(errors);
    } else {
        resolve(data);
    }
});



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/chaos.js